__webpack_require__.p = "https://betaadmin.prefacetoislam.com/";